import type {EditTaskFormPayload} from "./edit-task.schema";
import type {UpdateTaskRequest} from "@project/sdk/admin";

export const editTaskMapper = {
  toSdk: (payload: EditTaskFormPayload): UpdateTaskRequest => ({
    title: payload.title,
    status: payload.status,
    dueAt: payload.dueAt,
  }),
};
